import 'slick-carousel'
import { find, findFirst } from 'helpers/vanilla'

//const $ = window.jQuery

const HeroSlider = () => {

  const name = 'slider_hero'
  let $slider_hero

  const loadCondition = () => {
    $slider_hero = findFirst('.hero-slider')
    return $slider_hero
  }

  const init = () => {

    var $slider = $('.hero-slider-inner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      speed: 600,
      //autoplay: true,
      slide: '.hero-slider-item'
    })

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){

      var next = $(slick.$slides[nextSlide]);
      //console.log(next);

      if( next.hasClass('slide-image') ) {
        $('.hero-slider .signet').addClass('center');
        $('.hero-slider span').addClass('hidden');
      } else {
        $('.hero-slider .signet').removeClass('center');
        $('.hero-slider span').removeClass('hidden');
      }
    });

  }

  //init()
  return { loadCondition, name, init }
}

export default HeroSlider



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/components/slider-hero.js